import * as display from "public/display-utils.js";
import Splide from '@splidejs/splide';
const $ = require("jquery");

function generateRandomId(prefix = 'slider-') {
    return prefix + Math.random().toString(36).substr(2, 9);
}

var slideIt = function (splideInstance, sliderId, props) {
    if (splideInstance) {
        splideInstance.destroy();
    }

    var splide = new Splide(sliderId, {
        // Splide configuration
        perPage: props.columns,
        rewind: true,
        type: 'loop',
        autoplay: props.autoplay,
        paginationDirection: props.direction,
        arrows: props.arrows,
        pagination: props.dots,
        gap: props.spacing,
        //perMove: 1,
        //flickPower: 200,
        //autoWidth: true,
        //focus: 'center',
        //omitEnd: true,
        //breakpoints: {
        //    750: {
                // perPage: props.m_columns,
                // autoplay: props.m_autoplay,
                // paginationDirection: props.m_direction,
                // arrows: props.m_arrows,
                // gap: props.m_spacing,
                // pagination: props.m_dots
        //    }
        //}
    });
    splide.mount();

    return splide;
}

class tiktokWidget extends HTMLElement {
    constructor() {
        super();
        this.waterMark = undefined;
        this.splide = null;
        this.sliderId = generateRandomId();
        //this.style.width ="100%"; 
        //this.style.height ="max-content"; 
        //this.style["min-height"] ="max-content";
        this.shadow = this.attachShadow({ mode: 'open' });
        const style = document.createElement('style');
        style.textContent = `
            :host {
                width: 100%;
                display: block; /* or 'flex' depending on your needs */
                min-height: max-content;
                height: max-content;
            }
            /* Add more styles for your widget here */
        `;
        this.shadow.appendChild(style);
    }

    connectedCallback() {
        let attribute_settings = this.getAttribute('settings');
        let settings = JSON.parse(attribute_settings);
        this.init(settings);
    }

    attributeChangedCallback(name, oldValue, newValue) {
        if (name === "settings") {
            let settings = JSON.parse(newValue);
            this.init(settings)
        }
    }
    init(settings) {
        while (this.shadow.firstChild) {
            this.shadow.removeChild(this.shadow.firstChild);
        }
        if (settings?.props.layout === "slider") {
            this.createSlider(settings);
        } else if (settings?.props.layout === "grid") {
            this.createGrid(settings)
        }
        if (settings && !settings.props.watermark) this.createWaterMark();
        else this.removeWaterMark();
    }
    createSlider(settings) {
        let repeater = display.create_Slider(document, settings, this.sliderId);
        this.shadow.appendChild(repeater);
        let mainHolder = repeater.querySelector('.splide');

        if (mainHolder) {
            this.splide = slideIt(this.splide, mainHolder, settings.props);
        }
    }

    // createSlider(settings) {
    //     let repeater = display.create_Slider(document, settings, this.sliderId);
    //     this.shadow.appendChild(repeater);
    //     this.splide = slideIt(this.splide, this.sliderId, settings.props);
    // }
    createGrid(settings) {
        let repeater = display.create_Grid(document, settings);
        this.shadow.appendChild(repeater);
    }

    createWaterMark() {
        this.waterMark = display.create_WaterMark(document);
        this.shadow.appendChild(this.waterMark);
    }
    removeWaterMark() {
        if (this.waterMark) {
            this.shadow.removeChild(this.waterMark);
            this.waterMark = undefined;
        }
    }

    static get observedAttributes() {
        return ['settings'];
    }
}

customElements.define('tiktok-widget', tiktokWidget);